﻿import httpService from "./httpService";

export default {
  getUserSignature: async id => httpService.get(`/usersignatureimage/getSignatureData/${id}`),

  saveUserSignatureImage: async userSignatureImage => httpService.post(`/usersignatureimage/`, userSignatureImage),

  updateUserSignatureImage: async userSignatureImage => httpService.put(`/usersignatureimage/`, userSignatureImage),
};
